/* Bloom ATX - 21+ entry age gate behaviour (Layer 1).
   The overlay is visible by default (fail-safe). theme.liquid sets html[data-age-ok]
   synchronously for remembered visitors (no flash). This script wires the buttons,
   persists confirmation WITH a timestamp, honours the merchant "Remember for (days)"
   setting (read from data-remember-days), and shows the decline state. Scroll lock is
   handled in CSS via html:not([data-age-ok]). */
(function () {
  var KEY = 'bloom_age_ok';
  var gate = document.getElementById('BloomAgeGate');
  if (!gate) return;

  var root = document.documentElement;
  var days = parseInt(gate.getAttribute('data-remember-days'), 10);
  if (isNaN(days)) days = 30;

  function remembered() {
    if (days <= 0) return false; // "ask on every visit"
    try {
      var raw = localStorage.getItem(KEY);
      if (!raw || raw.charAt(0) !== '{') return false; // ignore legacy 'yes' value
      var d = JSON.parse(raw);
      return !!(d && d.ok === true && (Date.now() - (d.ts || 0)) < days * 86400000);
    } catch (e) { return false; }
  }

  function allow(persist) {
    if (persist) {
      try { localStorage.setItem(KEY, JSON.stringify({ ok: true, ts: Date.now() })); } catch (e) {}
    }
    root.setAttribute('data-age-ok', '');
  }

  // Already remembered (head script will usually have set this first).
  if (remembered()) { allow(false); return; }

  // Don't trap the merchant inside the theme editor.
  if (window.Shopify && Shopify.designMode) { allow(false); return; }

  var confirmBtn = gate.querySelector('[data-age-confirm]');
  var denyBtn = gate.querySelector('[data-age-deny]');
  var card = gate.querySelector('[data-age-card]');
  var deniedTpl = gate.querySelector('[data-age-denied]');

  if (confirmBtn) {
    confirmBtn.addEventListener('click', function () { allow(true); });
  }

  if (denyBtn) {
    denyBtn.addEventListener('click', function () {
      if (card && deniedTpl) card.innerHTML = deniedTpl.innerHTML;
    });
  }
})();
